import React from 'react';
import { motion } from 'framer-motion';
import { content } from '../data/content';
import { Link } from 'react-scroll';

const Hero = () => {
  return (
    <section id="profile" className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20">
          
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="flex-1 text-center md:text-left"
          >
            <span className="inline-block py-1 px-3 rounded-full bg-slate-200 text-slate-700 text-xs font-bold tracking-wider mb-6 uppercase">
              Executive Portfolio
            </span>
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-slate-900 leading-tight mb-6">
              {content.profile.title}
            </h1>
            <p className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed max-w-2xl mx-auto md:mx-0">
              {content.profile.tagline}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <Link to="contact" smooth={true} duration={500} className="px-8 py-3 bg-slate-900 text-white rounded-md font-medium hover:bg-slate-800 transition-colors cursor-pointer text-center">
                Get in Touch
              </Link>
              <Link to="expertise" smooth={true} duration={500} className="px-8 py-3 border border-slate-300 text-slate-700 rounded-md font-medium hover:bg-slate-100 transition-colors cursor-pointer text-center">
                View Expertise
              </Link>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex-1 relative"
          >
            <div className="relative aspect-[4/5] md:aspect-square w-full max-w-md mx-auto overflow-hidden rounded-2xl shadow-2xl">
              <img 
                src={content.profile.image} 
                alt={content.profile.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-slate-200 rounded-full -z-10 opacity-50"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 border-2 border-slate-200 rounded-full -z-10 opacity-50"></div>
          </motion.div>

        </div>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 md:mt-32 max-w-4xl mx-auto text-center"
        >
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-6">About Maries</h3>
          <p className="text-lg md:text-2xl font-serif text-slate-800 leading-relaxed">
            "{content.profile.bio}"
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;